/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Activity_Noactivitytitle2Inputs */

const id_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada aktivitas`)
};

const ms_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada aktiviti`)
};

const da_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen aktivitet endnu`)
};

const de_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Aktivität`)
};

const en_us2_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No activity yet`)
};

const es_es2_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay actividad`)
};

const es_mx2_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay actividad`)
};

const fil_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang aktibidad`)
};

const fr_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune activité pour le moment`)
};

const it_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna attività`)
};

const hu_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Még nincs tevékenység`)
};

const nl_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen activiteit`)
};

const no_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen aktivitet ennå`)
};

const pl_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak aktywności`)
};

const pt_br2_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma atividade ainda`)
};

const pt_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma atividade ainda`)
};

const ro_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Încă nicio activitate`)
};

const fi_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä toimintaa`)
};

const sv_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen aktivitet än`)
};

const vi_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có hoạt động`)
};

const tr_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz aktivite yok`)
};

const cs_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádná aktivita`)
};

const bg_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все още няма активност`)
};

const ru_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока нет активности`)
};

const uk_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активності ще немає`)
};

const ar_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد نشاط بعد`)
};

const hi_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी तक कोई गतिविधि नहीं`)
};

const th_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีกิจกรรม`)
};

const ja_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだアクティビティはありません`)
};

const zh_cn2_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无动态`)
};

const zh_hant1_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暫無動態`)
};

const ko_profile_activity_noactivitytitle2 = /** @type {(inputs: Profile_Activity_Noactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 활동이 없습니다`)
};

/**
* | output |
* | --- |
* | "No activity yet" |
*
* @param {Profile_Activity_Noactivitytitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_activity_noactivitytitle2 = /** @type {((inputs?: Profile_Activity_Noactivitytitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Activity_Noactivitytitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_activity_noactivitytitle2(inputs)
	if (locale === "ms") return ms_profile_activity_noactivitytitle2(inputs)
	if (locale === "da") return da_profile_activity_noactivitytitle2(inputs)
	if (locale === "de") return de_profile_activity_noactivitytitle2(inputs)
	if (locale === "en-US") return en_us2_profile_activity_noactivitytitle2(inputs)
	if (locale === "es-ES") return es_es2_profile_activity_noactivitytitle2(inputs)
	if (locale === "es-MX") return es_mx2_profile_activity_noactivitytitle2(inputs)
	if (locale === "fil") return fil_profile_activity_noactivitytitle2(inputs)
	if (locale === "fr") return fr_profile_activity_noactivitytitle2(inputs)
	if (locale === "it") return it_profile_activity_noactivitytitle2(inputs)
	if (locale === "hu") return hu_profile_activity_noactivitytitle2(inputs)
	if (locale === "nl") return nl_profile_activity_noactivitytitle2(inputs)
	if (locale === "no") return no_profile_activity_noactivitytitle2(inputs)
	if (locale === "pl") return pl_profile_activity_noactivitytitle2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_activity_noactivitytitle2(inputs)
	if (locale === "pt") return pt_profile_activity_noactivitytitle2(inputs)
	if (locale === "ro") return ro_profile_activity_noactivitytitle2(inputs)
	if (locale === "fi") return fi_profile_activity_noactivitytitle2(inputs)
	if (locale === "sv") return sv_profile_activity_noactivitytitle2(inputs)
	if (locale === "vi") return vi_profile_activity_noactivitytitle2(inputs)
	if (locale === "tr") return tr_profile_activity_noactivitytitle2(inputs)
	if (locale === "cs") return cs_profile_activity_noactivitytitle2(inputs)
	if (locale === "bg") return bg_profile_activity_noactivitytitle2(inputs)
	if (locale === "ru") return ru_profile_activity_noactivitytitle2(inputs)
	if (locale === "uk") return uk_profile_activity_noactivitytitle2(inputs)
	if (locale === "ar") return ar_profile_activity_noactivitytitle2(inputs)
	if (locale === "hi") return hi_profile_activity_noactivitytitle2(inputs)
	if (locale === "th") return th_profile_activity_noactivitytitle2(inputs)
	if (locale === "ja") return ja_profile_activity_noactivitytitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_activity_noactivitytitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_activity_noactivitytitle2(inputs)
	return ko_profile_activity_noactivitytitle2(inputs)
});
export { profile_activity_noactivitytitle2 as "profile.activity.noActivityTitle" }